import ValuePropositionSection from "./components/ValueProposition";
import FeaturesSection from "./components/Features";
import PlansSection from "./components/Plans";

export default function JoinAsCompanySection() {
  return (
    <>
      <ValuePropositionSection />

      <FeaturesSection />

      <PlansSection />
    </>
  );
}
